<template>
  <!--询盘服务-->
  <div class="ab-iserver-price">
    <div class="ab-iserver-price-header flex-row">
      <div class="ab-banner-header flex-col">
        <MainNav />
      </div>
    </div>
    <priceTabOne />
    <priceTabTwo />
    <priceTabThree />

    <!--服务列表价格清单-->
    <!-- <PackageList></PackageList> -->
    <!--优势对比-->
    <!-- <CompareList :dataList="competitiveData" /> -->
    <!--问题列表-->
    <QuestionList :dataList="questionData"></QuestionList>
    <!--已服务列表-->
    <CustomerList></CustomerList>

    <FooterBanner></FooterBanner>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import MainNav from "@/components/MainNav.vue";
import Abbutton from "@/components/Abbutton.vue";
import AbBlock from "@/components/AbBlock.vue";
import Features from "@/components/Features.vue";
import PackageList from "./components/packageList.vue";
import QuestionList from "./components/questionList.vue";
import CustomerList from "@/components/CustomerList.vue";
import FooterBanner from "@/components/FooterBanner.vue";
// import InquiryModalVue from "@/components/InquiryModal.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import Digit from "./components/Digit.vue";
import CompareList from "./components/compareList.vue";
import metaInfo from "@/metaInfo";
import priceTabOne from "./components/priceTabOne.vue";
import priceTabTwo from "./components/priceTabTwo.vue";
import priceTabThree from "./components/priceTabThree.vue";
import { usePageTracker } from "@/utils/pageTracker";

export default {
  metaInfo: metaInfo["tradeGeek"],
  components: {
    MainNav,
    Abbutton,
    Features,
    PackageList,
    QuestionList,
    CustomerList,
    AbBlock,
    FooterBanner,
    Digit,
    CompareList,
    inquiryModalVue,
    priceTabOne,
    priceTabTwo,
    priceTabThree,
  },
  data() {
    return {
      featsList: [
        {
          id: "1",
          title: "品牌官网建设",
          desc:
            "三合一响应式独立站建设，自研系统高性能优化页面加速，双站点服务器全球访问秒极响应，产品交互逻辑与视觉设计体验高度迎合国外买家浏览阅读行为习惯。",
          icon_url: "icon_询盘数量有保障.png",
        },
        {
          id: "2",
          title: "智能化SNS营销",
          desc:
            "基于健全成熟的社媒体系提供全生命周期运营服务，高效自动化免翻墙营销模型，实时监测嗅探同行社媒主页行为旅程，多样化开发潜客，降低信息沟通难度。",
          icon_url: "icon_简化交互流程.png",
        },
        {
          id: "3",
          title: "自动化营销站群",
          desc:
            "运用领先的自动化站群技术快速实现海量关键词部署，20+云集Listing优化部署体系，针对性优化搜索引擎的收录，有效提升品牌曝光率及定向转化率。",
          icon_url: "icon_量化效果更明显.png",
        },
        {
          id: "4",
          title: "AI询盘获客",
          desc:
            "全面打通营销触点与SCRM，通过五维漏斗数字模型分析智选，智能NLP技术+人工校验去重，精准捕获锁定意向客户询盘，缩短营销链路，有效提高订单转化率。",
          icon_url: "icon_销售赋能工具.png",
        },
        {
          id: "5",
          title: "智能获客代理",
          desc:
            "聚合SaaS云生态部署，自建专业化获客代理平台，在线寻找获客代理人，精准定位目标客户，降低企业人力运营投入成本，全面提升B2B企业营销获客效能。",
          icon_url: "icon_多套应用集于一体.png",
        },
        {
          id: "6",
          title: "全渠道营销整合",
          desc:
            "通过品牌官网、营销站群、行业平台、社媒推广、社媒嗅探、获客代理等渠道为用户快速搭建全链路营销矩阵，以高效拓展海外营销链路，助力品牌顺利出海。",
          icon_url: "icon_全域数字营销.png",
        },
      ],
      questionData: [
        {
          q: "外贸极客是什么？",
          a:
            "外贸极客是一站式智能量化营销服务平台，结合CRM和AI技术，帮助外贸B2B出口企业高效地拓展全球市场、精准获客和管理客户，从而降低运营成本并提升成交转化率。",
        },
        {
          q: "外贸极客的核心价值是什么？",
          a:
            "外贸极客主要有四大核心价值：\n1. 大幅提高效率并降低成本。\n2. 降低专业门槛，让非专业人士也能有效操作。\n3. 快速精准地获取潜在客户。\n4. 提升成交转化率，提高销售额。",
        },
        {
          q: "外贸极客能为企业解决什么问题？",
          a:
            "外贸极客可以帮助企业解决以下问题：\n1. 提高营销效率，减少人工操作。\n2. 降低运营和人员成本。\n3. 快速找到和吸引潜在客户。\n4. 精准管理客户和商机，提升成交率。\n5. 实现全流程、全方位的客户管理和售后服务。",
        },
        {
          q: "外贸极客的主要功能有哪些？",
          a:
            "外贸极客包含以下主要功能：\n1. 营销管理：提供智能助手、智能生成高质量营销内容、市场分析和竞品管理等。\n2. 推广引流：包括智能建站、社媒营销、智能推广、智能客服、智能投放和邮件营销。\n3. 快速获客：通过商机监控、客户搜索和智能推荐等功能，帮助企业快速获得潜在客户。\n4. 客户管理：智能进行客户分配、线索培育、商机管理、售后服务和通讯工具集成。\n5. 服务支持：基础培训、辅助实施和高性价比的人工服务。",
        },
        {
          q: "外贸极客适合哪些类型的企业？",
          a:
            "外贸极客适合：\n1. 追求高效和降低运营成本的企业。\n2. 缺乏专业运营人员但需要自动化解决方案的企业。\n3. 希望快速、精准获客的企业。\n4. 想要尝试人工智能营销的企业。\n5. 精力有限，需要智能自动化工具辅助的企业。",
        },
        {
          q: "外贸极客如何帮助企业提高SEO效果？",
          a:
            "通过智能建站和一键生成高质量独立站和站群，并进行智能SEO优化，外贸极客帮助企业提升在搜索引擎中的排名，增大曝光和引流。",
        },
        {
          q: "是否提供培训和支持？",
          a:
            "是的，外贸极客提供基础操作指南和视频教程，让用户快速上手。此外，我们还提供辅助实施服务和高性价比的专业人工服务，确保您的营销活动顺利运行。",
        },
        {
          q: "外贸极客如何保障数据安全？",
          a:
            "外贸极客采用先进的安全技术，确保客户数据完全保密和安全。我们遵循严格的数据保护政策，并定期进行安全审查和更新。",
        },
      ],
      competitiveData: [
        {
          other: "传统CRM",
          abke: "外贸极客",
          otherData: [
            "仅支持基本的营销活动管理",
            "仅集成了电子邮件和电话类基本通讯方式",
            "依赖于数据输入和人工操作",
            "仅支持邮件、电话、短信",
            "仅提供一定程度的自动化功能",
            "不提供",
            "仅聚焦于客户数据的管理分析",
            "仅提供产品",
          ],
          abkeData: [
            "多维营销素材与内容创造",
            "广泛的营销渠道整合",
            "强大的数据获取和分析能力",
            "全方位沟通方式支持",
            "高度智能化的数字人",
            "定制化资讯推送",
            "全面数字化",
            "专业人性化服务",
          ],
        },
        {
          other: "传统B2B平台",
          abke: "外贸极客",
          otherData: [
            "侧重于提供在线交易的平台，功能相对固定，更多依赖人工操作，智能化程度有限。",
            "通常提供标准化服务，企业需要自行调整策略以符合平台，可能难以充分体现企业独特性。",
            "可能会涉及较高的会员费用，广告投放成本及交易手续费，整体成本可能较高。",
            "虽然也提供客户数据库访问，但在数据的深度整合与智能运用方面可能不如人工智能强大。",
            "主要集中在交易撮合，其他营销环节可能需要额外的工具和服务支持。",
            "用户体验依赖于平台自身的设计，操作复杂度和用户满意度因平台而异。",
            "提供的信息可能相对滞后，且不够针对性和个性化。",
            "",
          ],
          abkeData: [
            "借助人工智能的AGI与AIGC能力，能自动完成许多营销和客服工作，大幅提升工作效率，实现24/7的营销活动和客户服务。",
            "通过AI技术，客户可享受定制化的服务。",
            "通过减少人力需求，提升工作效率，最终帮助企业降低营销成本，提高ROI（投资回报率）。",
            "整合了全球的企业数据、海关数据、联系方式等多种有效数据源，并辅以先进的数据匹配推荐能力，可快速获取潜在客户信息。同时，AI的应用能够更准确地实现目标客户分析，达到更精准的推广效果。",
            "从内容创作、品牌推广、客户管理到售后服务等，能提供一条龙的服务，让企业在一款软件中完成所有营销活动。",
            "提供直观、易操作的界面和人工智能数字人的互动体验，缩短用户学习曲线，提升用户使用满意度。",
            "通过实时的行业资讯收集和市场趋势分析，帮助企业快速响应市场变化，把握业务发展机会。",
            "",
          ],
        },

        {
          other: "传统营销代运营服务",
          abke: "外贸极客",
          otherData: [
            "依赖于人力执行",
            "长期依赖代运营公司，营销成本高",
            "服务标准化程度高，可能无法完全贴合特定企业的个性化需求。",
            "决策依赖服务团队经验判断，缺乏大数据支撑，可能导致决策缓慢和不精准。",
            "只覆盖营销的一部分流程，需要企业自己协调多方面工作。",
            "经验积累受限于团队成员能力，难以快速适应技术和市场的迅速变化。",
            "",
            "",
          ],
          abkeData: [
            "采用先进的AIGC和AGI技术自动化管理营销内容和流程，24/7不间断服务",
            "降低了对专业营销团队的依赖，提供数据分析支持，精准的投资回报评估",
            "提供高度定制化服务，能够根据企业的具体需求快速调整和优化营销策略，更好地适应市场变化。",
            "整合全球营销渠道和合法数据源，提供强大的数据分析及智能决策功能，帮助企业实时调整战略，减少决策误差。",
            "覆盖营销全流程，从素材创作到推广管理，再到客户沟通和售后服务，实现营销工作的完整闭环。",
            "利用人工智能持续学习和自我优化的特点，保证营销策略随时处于行业前沿。",
            "",
            "",
          ],
        },
        {
          other: "传统建站和SEO服务",
          abke: "外贸极客",
          otherData: [
            "仅注重网站建设和搜索引擎优化",
            "优化工作往往周期长，更新不及时，需要长期等待搜索引擎结果的提升",
            "费用通常较高，需要支付给专业人员和长时间的优化周期费用。",
            "提供的服务通常是标准化，缺乏个性化配置和智能互动。",
            "往往依赖于外部的数据分析工具来实施策略，难以获得即时的、针对性的市场分析。",
            "服务完成后，企业往往需要自己更新和维护，对于没有专业技能的企业来说是一个挑战。",
            "",
            "",
          ],
          abkeData: [
            "整合全球主要的营销渠道 不仅关注网站建设和SEO，还通过AIGC创建多语种营销内容，提供全方位的网络推广策略及执行。",
            "应用AGI技术，能够快速反应市场变化，实时更新优化营销内容，并能高效执行营销策略，确保企业信息的即时性和前瞻性。",
            "通过数字化的服务功能节省人工成本，企业只需关注战略决策，由智能体完成从内容创作到客户服务的全流程工作，大大降低人力与时间成本。",
            "提供定制化的专业销售管理智能数字人，用户可以通过简单的指令即可完成复杂的营销任务，并实现客户服务的智能化，提升用户体验",
            "整合了合法的数据源，结合自身的数据分析决策能力，能够提供更准确的市场预测和客户分析，帮助企业做出更精准的营销决策。",
            "不仅在产品提供阶段提供全面支持，在后续的使用过程中也提供培训、引导、辅助甚至代操作的人工服务，确保企业营销的持续性和稳定性。",
            "",
            "",
          ],
        },
        {
          other: "传统客户线索检索类服务",
          abke: "外贸极客",
          otherData: [
            "仅提供基础数据查询，帮助企业寻找潜在的客户信息。",
            "需要用户主动分析数据，决策营销策略，执行可能会受限于人力",
            "缺乏内容创作的支持，可能需要企业自己投入资源来完成。",
            "需要企业自行开发和转化，周期长且效率不高。",
            "仅依赖有限的数据源或者更新不够及时。",
            "要求较多的人力和时间资源来处理获得的信息。",
            "缺乏客户服务的自动化和个性化。",
            "不包含决策辅助工具，用户需要自己分析和决策",
          ],
          abkeData: [
            "不仅提供数据检索，还集成了内容创作管理、全渠道推广、通讯方式管理、数字人销售、行业资讯服务等多个功能，是一体化的营销解决方案。",
            "利用人工智能AGI技术自动化完成复杂任务，并基于统计分析给出优化建议，实现高效智能营销。",
            "通过AIGC技术，为用户快速创建并维护多语种营销内容，确保品牌信息的国际化和本地化传播。",
            "结合实时数据采集和智能推荐系统快速识别潜在客户，缩短获取到成交的周期。",
            "整合了多种实时的、合法的数据源，包括全球企业和海关数据，为企业提供全面的视角。",
            "基于智能数字化处理减轻了企业对人力的依赖，降低了成本，并提高了营销的ROI。",
            "提供多语种的客户服务智能体，具备实时响应和个性化交互的能力。",
            "提供数据分析和决策建议工具，帮助用户快速准确地做出营销策略决定。",
          ],
        },
        {
          other: "传统代理广告投放服务",
          abke: "外贸极客",
          otherData: [
            "需要通过人工操作来设计广告计划、选择投放渠道和执行投放，流程繁琐，耗时较长。",
            "通常会收取额外的管理费用或服务费，增加企业的营销成本。",
            "在广告定位上可能存在泛化，导致营销资源无法精准定位目标客户群体。",
            "对于市场变化的响应可能较慢，调整计划需要时间。",
            "可能无法全面整合不同的营销渠道和工具",
            "",
            "",
            "",
          ],
          abkeData: [
            "集成了AI智能分析、执行与优化，可以实时自动调整广告策略，提高投放效果，减少时间消耗，确保营销活动的连续性和时效性。",
            "降低了对人力的依赖，通过AI减少了人工干预，显著降低整体营销预算，并且避免了可能的人为失误导致的成本浪费。",
            "利用高级数据分析和学习算法，确保广告投放能精确对接目标客户的需求，实现个性化营销，提高转化率。",
            "动用AGI技术，能实时收集市场反馈并快速响应，做出即时优化调整，提升营销活动的灵活度和应变能力。",
            "结合了AIGC和AGI技术，不仅整合了全球主要营销渠道，还能创作多语种内容，提供综合性的数字化营销解决方案。",
            "",
            "",
            "",
          ],
        },
      ],
      visible: false,
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass">
.ab-iserver-price .ab-question .q-list .q-item .q-block{
height:8rem
}
.ab-iserver-price-header {
  // height:620px;
  // background: url('~@/assets/images/外贸极客_banner.png') 100% no-repeat;
  width: 100%;
  background-size:cover;
  .ab-btn {
    font-weight: 800;
font-size: 26px;
  }
}

.ab-iserver-price .ab-banner-header {
  width: 100%;
  height: 100%;

  .ab-banner-info{
    padding-top:74px;
    padding-left:145px;
    .ab-banner-name{

      height: 69px;
      font-family: AlibabaPuHuiTiM;
      color: #333333;
      line-height: 54px;
font-size: 46px;
    }
    .ab-banner-tag {
      display: flex;
      column-gap: 48px;
      margin-bottom:40px;
      .tagItem {
        background: #FFFFFF;
border-radius: 6px;
padding: 4px 15px;
font-size: 16px;
color: #1A87FD;
font-family: AlibabaPuHuiTiM;
      }
    }

    .ab-banner-desc{
      width: 549px;
      margin-bottom:20px;
      font-family: Alibaba-PuHuiTi-R;
      font-weight: normal;
      color: rgba(51,51,51,0.4);
      line-height: 36px;
      padding-top: 20px;
    }
    .ab-banner-btn{
      width:200px;
      display: flex;
        column-gap: 18px;
      .ab-banner-btn-outline {
          border: 0.02667rem solid #0076FF;
          background: transparent;
          a {
            color: #0076FF !important;
            }
          }
    }
  }
}

.iserver-product-features{
  padding-top: 55px;
  .features-list{
    padding-top: 62px;
  }
}
</style>
